/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistorySocialHistoryCreateAliases {
  AUTOCOMPLETE_BRAND_SEARCH = 'autocomplete-brand-search',
  AUTOCOMPLETE_CLASSIFICATION_DOMAIN = 'autocomplete-classification-domain',
  AUTOCOMPLETE_FREQUENCY_DOMAIN = 'autocomplete-frequency-domain',
  AUTOCOMPLETE_SECURITY_LEVEL_DOMAIN = 'autocomplete-security-level-domain',
  AUTOCOMPLETE_TYPE_SEARCH = 'autocomplete-type-search',
  AUTOCOMPLETE_UNIT_MEASURE_SEARCH = 'autocomplete-unit-measure-search',
  CHECKBOX_DENIES_HABITS = 'checkbox-denies-habits',
  CHECKBOX_DISPLAY_PATIENT_ALERTS = 'checkbox-display-patient-alerts',
  CHECKBOX_INSERT_LIST_PROBLEMS = 'checkbox-insert-list-problems',
  DATE_FIELD_END_DATE = 'date-field-end-date',
  DATE_FIELD_START_DATE = 'date-field-start-date',
  FETCH_BRAND_SEARCH = 'fetch-brand-search',
  FETCH_CLASSIFICATION_DOMAIN = 'fetch-classification-domain',
  FETCH_FREQUENCY_DOMAIN = 'fetch-frequency-domain',
  FETCH_SECURITY_LEVEL_DOMAIN = 'fetch-security-level-domain',
  FETCH_TYPE_SEARCH = 'fetch-type-search',
  FETCH_UNIT_MEASURE_SEARCH = 'fetch-unit-measure-search',
  FIELD_AGE_EXPERIENCE = 'field-age-experience',
  FIELD_AGE_REGULAR_USE = 'field-age-regular-use',
  FIELD_BRAND_SEARCH = 'field-brand-search',
  FIELD_CLASSIFICATION_DOMAIN = 'field-classification-domain',
  FIELD_CONDITION = 'field-condition',
  FIELD_CONSEQUENCES = 'field-consequences',
  FIELD_DENIES_HABITS = 'field-denies-habits',
  FIELD_DESCRIPTIVE_QUANTITY = 'field-descriptive-quantity',
  FIELD_DISPLAY_PATIENT_ALERTS = 'field-display-patient-alerts',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FAMILY_ANTECEDENTS = 'field-family-antecedents',
  FIELD_FREQUENCY_DOMAIN = 'field-frequency-domain',
  FIELD_INSERT_LIST_PROBLEMS = 'field-insert-list-problems',
  FIELD_NOTES = 'field-notes',
  FIELD_QUANTITY = 'field-quantity',
  FIELD_SECURITY_LEVEL_DOMAIN = 'field-security-level-domain',
  FIELD_START_DATE = 'field-start-date',
  FIELD_TOTAL_PACKS = 'field-total-packs',
  FIELD_TYPE_SEARCH = 'field-type-search',
  FIELD_UNIT_MEASURE_SEARCH = 'field-unit-measure-search',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_ONE = 'form-one',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  HEALTH_HISTORY_SOCIAL_HISTORY_ADD_LAYOUT = 'health-history-social-history-add-layout',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_AGE_EXPERIENCE = 'input-age-experience',
  INPUT_AGE_REGULAR_USE = 'input-age-regular-use',
  INPUT_DESCRIPTIVE_QUANTITY = 'input-descriptive-quantity',
  INPUT_QUANTITY = 'input-quantity',
  INPUT_TOTAL_PACKS = 'input-total-packs',
  MAPPER_BRAND_SEARCH = 'mapper-brand-search',
  MAPPER_CLASSIFICATION_DOMAIN = 'mapper-classification-domain',
  MAPPER_FREQUENCY_DOMAIN = 'mapper-frequency-domain',
  MAPPER_SECURITY_LEVEL_DOMAIN = 'mapper-security-level-domain',
  MAPPER_TYPE_SEARCH = 'mapper-type-search',
  MAPPER_UNIT_MEASURE_SEARCH = 'mapper-unit-measure-search',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  RADIO_GROUP_CONDITION = 'radio-group-condition',
  TEXT_AREA_CONSEQUENCES = 'text-area-consequences',
  TEXT_AREA_FAMILY_ANTECEDENTS = 'text-area-family-antecedents',
  TEXT_AREA_NOTES = 'text-area-notes',
  TEXT_BRAND_SEARCH = 'text-brand-search',
  TEXT_CLASSIFICATION_DOMAIN = 'text-classification-domain',
  TEXT_FREQUENCY_DOMAIN = 'text-frequency-domain',
  TEXT_SECURITY_LEVEL_DOMAIN = 'text-security-level-domain',
  TEXT_TYPE_SEARCH = 'text-type-search',
  TEXT_UNIT_MEASURE_SEARCH = 'text-unit-measure-search',
  WIZARD = 'wizard',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { HealthHistorySocialHistoryCreateAliases };
